import React from 'react';
import { Button, Text } from '@chakra-ui/react';
import { LuCopy, LuClipboardCheck } from 'react-icons/lu';

export function CopyChartButton({ status, onClick }) {
  return <Button
    size="sm"
    variant="outline"
    flexShrink={0}
    onClick={onClick}
    disabled={status === 'copying'}
    data-html2canvas-ignore="true"
    aria-live="polite"
  >
    {status === 'copied' ? <LuClipboardCheck aria-hidden="true" /> : <LuCopy aria-hidden="true" />}
    {status === 'copying' ? 'Copying...' : status === 'copied' ? 'Copied!' : status === 'error' ? 'Copy failed' : 'Copy Chart'}
  </Button>;
}

export function ChartWatermark() {
  return <Text
    data-chart-watermark="true"
    position="absolute"
    bottom="2"
    right="4"
    fontSize="xs"
    color="gray.400"
    opacity={0.7}
    pointerEvents="none"
    userSelect="none"
  >dcfteacher.com</Text>;
}
